export const metaMap: Record<
    string,
    { title: string; description: string; keywords: string }
> = {
    Home: {
        title: "Home - iTalent",
        description: "Welcome to iTalent - your trusted talent partner.",
        keywords: "iTalent, home, talent solutions",
    },
    About: {
        title: "About Us - iTalent",
        description: "Learn more about iTalent and our mission.",
        keywords: "about iTalent, our mission, team",
    },
    Services: {
        title: "Services - iTalent",
        description: "Explore our range of professional services.",
        keywords: "services, consulting, iTalent services",
    },
    Certifications: {
        title: "Certifications - iTalent",
        description: "Browse our certifications and credentials.",
        keywords: "certifications, compliance, iTalent credentials",
    },
    Gallery: {
        title: "Gallery - iTalent",
        description: "Take a look at our past events and achievements.",
        keywords: "gallery, events, achievements",
    },
    "Contact Us": {
        title: "Contact Us - iTalent",
        description: "Get in touch with us for collaboration or inquiries.",
        keywords: "contact, reach us, get in touch",
    },
};

export const servicesMetaMap: Record<
    string,
    { title: string; description: string; keywords: string }
> = {
    "Statutory Compliance": {
        title: "Statutory Compliance - iTalent",
        description:
            "Ensure your business stays compliant with iTalent's expert statutory compliance services.",
        keywords:
            "statutory compliance, legal compliance, business compliance, iTalent",
    },
    "Labour Compliance": {
        title: "Labour Compliance - iTalent",
        description:
            "Stay up to date with labour laws and regulations with iTalent's expert labour compliance services.",
        keywords:
            "labour compliance, employment law, labor law services, HR compliance, iTalent",
    },
    "Payroll Management Services": {
        title: "Payroll Management Services - iTalent",
        description:
            "Streamline your payroll processes with iTalent’s professional payroll management services tailored for businesses of all sizes.",
        keywords:
            "payroll management, salary processing, payroll outsourcing, payroll services, iTalent",
    },
    "Registration Certificate": {
        title: "Registration Certificate - iTalent",
        description:
            "Get assistance with obtaining essential business registration certificates through iTalent’s expert compliance services.",
        keywords:
            "registration certificate, business registration, legal documentation, company certification, iTalent",
    },
    "Background Verification": {
        title: "Background Verification - iTalent",
        description:
            "Ensure trustworthy hiring with iTalent’s thorough background verification services for candidates and employees.",
        keywords:
            "background verification, employee screening, candidate verification, pre-employment checks, iTalent",
    },

    // statutory compliance subservices metaTags
    "Employees’ Provident Funds and Miscellaneous Provisions Act, 1952": {
        title: "EPF & MP Act, 1952 - iTalent",
        description:
            "iTalent ensures compliance with the Employees’ Provident Funds and Miscellaneous Provisions Act, 1952 for secure employee savings and employer obligations.",
        keywords:
            "EPF compliance, Provident Fund Act, employee savings, social security, iTalent",
    },

    "Employees’ State Insurance Act, 1948": {
        title: "ESI Act, 1948 - iTalent",
        description:
            "Stay compliant with the Employees’ State Insurance Act, 1948 through iTalent’s expert services for employee medical benefits and social security.",
        keywords:
            "ESI compliance, employee insurance, ESI registration, social security, iTalent",
    },

    "Professional Tax Act, 1975": {
        title: "Professional Tax Act, 1975 - iTalent",
        description:
            "iTalent helps businesses adhere to the Professional Tax Act, 1975 ensuring accurate deductions and state-wise registrations.",
        keywords:
            "professional tax, PT compliance, tax deduction, state tax law, iTalent",
    },

    "Labour Welfare Fund Act, 1965": {
        title: "Labour Welfare Fund Act, 1965 - iTalent",
        description:
            "iTalent provides support in complying with the Labour Welfare Fund Act, 1965 to promote employee welfare and statutory deductions.",
        keywords:
            "labour welfare fund, statutory compliance, employee welfare, LWF Act, iTalent",
    },

    // labour compliance subservices metaTags
    "Contract Labour (Regulation & Abolition) Act, 1970": {
        title: "Contract Labour Regulation Act, 1970 - iTalent",
        description:
            "Ensure regulatory compliance with iTalent under the Contract Labour (Regulation & Abolition) Act, 1970 for safe and legal contract employment.",
        keywords:
            "contract labour, labour law, contractor compliance, CLRA Act, iTalent",
    },

    "Minimum Wages Act, 1948": {
        title: "Minimum Wages Act, 1948 - iTalent",
        description:
            "iTalent helps companies comply with the Minimum Wages Act, 1948 ensuring fair pay standards and wage structures for all workers.",
        keywords:
            "minimum wages, fair pay, wage compliance, labour act, iTalent",
    },

    "Payment of Bonus Act, 1965": {
        title: "Payment of Bonus Act, 1965 - iTalent",
        description:
            "Stay compliant with the Payment of Bonus Act, 1965 through iTalent’s services to ensure timely and lawful employee bonus payouts.",
        keywords:
            "bonus act, employee bonus, statutory payments, bonus compliance, iTalent",
    },

    "Employment Exchange (Compulsory Notification of Vacancies) Act, 1959": {
        title: "Employment Exchange Act, 1959 - iTalent",
        description:
            "iTalent supports your compliance with the Employment Exchange Act, 1959 by handling mandatory vacancy notifications and legal processes.",
        keywords:
            "employment exchange, vacancy notification, labour compliance, statutory act, iTalent",
    },

    "Sexual Harassment of Women at Workplace (Prevention, Prohibition & Redressal) Act, 2013":
        {
            title: "POSH Act, 2013 - iTalent",
            description:
                "iTalent ensures organizational compliance with the POSH Act, 2013, supporting safe workplaces for women through preventive and redressal measures.",
            keywords:
                "POSH Act, workplace harassment, women safety law, compliance services, iTalent",
        },

    "Shops and Commercial Establishments Act": {
        title: "Shops & Establishments Act - iTalent",
        description:
            "iTalent facilitates registration and compliance under the Shops and Establishments Act to meet state-wise labor regulations for commercial units.",
        keywords:
            "shops act, commercial establishments, business registration, labour law, iTalent",
    },

    // Payroll Management Services subservices metaTags
    "HRMS & Payroll System": {
        title: "HRMS & Payroll System - iTalent",
        description:
            "iTalent offers an all-in-one HRMS & Payroll System that streamlines HR operations, automates payroll processing, and enhances organizational efficiency.",
        keywords:
            "HRMS, payroll system, HR software, payroll automation, employee management, iTalent",
    },

    "Employee Self Service": {
        title: "Employee Self Service Portal - iTalent",
        description:
            "Empower your workforce with iTalent’s Employee Self Service (ESS) portal, allowing easy access to payslips, leave requests, and personal data.",
        keywords:
            "employee self service, ESS portal, HR portal, employee access, self-service HR, iTalent",
    },

    "Leave Management": {
        title: "Leave Management System - iTalent",
        description:
            "iTalent simplifies leave tracking and approval with an intelligent Leave Management System to help HR and employees manage leaves efficiently.",
        keywords:
            "leave management, leave tracker, HR software, leave system, employee leaves, iTalent",
    },

    "Time Attendance": {
        title: "Time & Attendance Management - iTalent",
        description:
            "Track employee hours with accuracy using iTalent’s Time & Attendance system, integrating biometric, web, and mobile check-ins.",
        keywords:
            "time tracking, attendance system, biometric attendance, HR management, iTalent",
    },

    "Mobile HR": {
        title: "Mobile HR Solutions - iTalent",
        description:
            "Stay connected on-the-go with iTalent’s Mobile HR solution, enabling employees and managers to handle HR tasks from anywhere.",
        keywords:
            "mobile HR, HR app, HR on the go, mobile workforce management, iTalent",
    },

    "Multi-level Workflow": {
        title: "Multi-level Workflow Automation - iTalent",
        description:
            "Streamline approvals and internal processes with iTalent’s customizable multi-level workflow system for HR, finance, and operations.",
        keywords:
            "workflow automation, multi-level approval, business process automation, HR workflows, iTalent",
    },

    // Background Verification subservices metaTags
    "Gap Check": {
        title: "Gap Check",
        description:
            "Identify and verify employment gaps in candidates' resumes with iTalent’s reliable Gap Check services for informed hiring decisions.",
        keywords:
            "gap check, employment verification, resume gap analysis, background verification, iTalent",
    },

    "Employment Verification": {
        title: "Employment Verification",
        description:
            "Validate past work history of candidates with iTalent’s Employment Verification services to ensure authenticity and reduce hiring risk.",
        keywords:
            "employment verification, work history verification, background check, HR screening, iTalent",
    },

    "Education Verification": {
        title: "Education Verification",
        description:
            "Ensure academic qualifications are accurate with iTalent’s Education Verification services for secure and compliant hiring.",
        keywords:
            "education verification, academic check, degree verification, candidate background check, iTalent",
    },

    "Government Id Verification": {
        title: "Government Id Verification",
        description:
            "Authenticate identity proof like Aadhaar, PAN, and more using iTalent’s Government ID Verification services.",
        keywords:
            "government ID verification, identity check, Aadhaar verification, PAN card verification, iTalent",
    },

    "FIR Check / Police Verification": {
        title: "FIR Check / Police Verification",
        description:
            "Verify criminal records through FIR and police checks with iTalent’s background screening solutions for secure hiring.",
        keywords:
            "police verification, FIR check, criminal background check, candidate screening, iTalent",
    },

    "Address Check": {
        title: "Address Check",
        description:
            "Confirm candidate residential details with iTalent’s Address Verification services, including physical address validation.",
        keywords:
            "address verification, residence check, background screening, candidate address validation, iTalent",
    },

    "Court Verification": {
        title: "Court Verification",
        description:
            "Check for any legal history or court records against candidates with iTalent’s Court Verification service.",
        keywords:
            "court verification, legal check, litigation history, background verification, iTalent",
    },

    "Reference Check": {
        title: "Reference Check",
        description:
            "Get reliable insights on candidate performance with iTalent’s professional Reference Check services from past employers or managers.",
        keywords:
            "reference check, professional reference, employment screening, background verification, iTalent",
    },
};
